<script>
export default {
  name: 'flashForwardButtonIcon',
  props: {
    time: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable -->
    <path d="M9.96997 0C5.31997 0 1.38997 3.03 -2.86102e-05 7.22L2.36997 8C3.41997 4.81 6.42997 2.5 9.96997 2.5C11.93 2.5 13.7 3.22 15.09 4.38L12.47 7H19.47V0L16.87 2.6C15.02 1 12.62 0 9.96997 0Z" fill="currentColor"/>
    <text x="50%" y="15" dominant-baseline="middle" text-anchor="middle" fill="currentColor" style="font-size: .9rem">{{ time }}</text>
    <!-- eslint-enable -->
  </svg>
</template>
